/**
 * Normalização de texto para busca — o banco compara com COLLATE ..._CI_AI (ignora acento e caixa),
 * então a comparação no cliente precisa ignorar os mesmos sinais, senão "joao" descarta "João".
 */
const normalizarParaBusca = (valor: string): string => (valor || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()

/**
 * Filtro de v-autocomplete que ignora acento e caixa. Usar nos autocompletes cuja lista é local;
 * quando a busca é remota, prefira `no-filter` e deixe o filtro no banco.
 */
const filtroSemAcento = (item: any, queryText: string, itemText: string): boolean => normalizarParaBusca(itemText)
  .indexOf(normalizarParaBusca(queryText)) > -1

export {
  normalizarParaBusca,
  filtroSemAcento,
}
